/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/appCardList.config.json';
import axios from 'axios';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_SUPPLIERS } from '../graphql';
import { VApplication } from '@/application';
import { BreadcrumbService } from '../../../../services/breadcrumbService';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface IGetHolderGroupProps {
  offset?: number;
  size?: number;
  where?: any;
}

export interface IAppCardListMethods extends IPluginMethodMap {
  getAppCardListProps(args: any): Promise<any>;
}
const getBreadcrumbService = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.BreadcrumbService') as BreadcrumbService;
};

export class AppCardListService implements IAgentPlugin {
  readonly methods: IAppCardListMethods;

  constructor() {
    this.methods = {
      getAppCardListProps: this.getAppCardListProps.bind(this),
    };
  }

  async getAppCardListProps(args: any) {
    // const storageService = StorageModule?.getInstance();
    // const srv = getBreadcrumbService();
    // const breadcrumbItems = srv?.getBreadCrumbItems();
    // const graphqlModule = getGraphQLModule();
    // const client = graphqlModule.getClient('graphql-gateway');
    // const orgDetails = storageService?.get('myProfile', 'local')?.orgData;
    // const orgId = orgDetails?.id;
    try {
      // if (client) {
      //   const res = await client.query({
      //     query: GET_SUPPLIERS,
      //     variables: {
      //       where: {
      //         id: orgId,
      //       },
      //       options: {
      //         limit: 12,
      //         offset: args?.offset || 0,
      //         sort: [
      //           {
      //             name: 'ASC',
      //           },
      //         ],
      //       },
      //     },
      //     fetchPolicy: 'network-only',
      //   });
      //   if (res?.data?.orgs) {
      //     let _templateData =
      //       res?.data?.orgs &&
      //       Array.isArray(res?.data?.orgs) &&
      //       res?.data?.orgs.length > 0
      //         ? this.formatHolderGroup(res?.data?.orgs[0]?.childrenOrgs)
      //         : [];
      //     let totalCount =
      //       res?.data?.orgs &&
      //       Array.isArray(res?.data?.orgs) &&
      //       res?.data?.orgs.length > 0
      //         ? res?.data?.orgs[0]?.childrenOrgsAggregate?.count
      //         : 0;
      //     console.log('getAppCardListProps =>', _templateData);
      //     return {
      //       appCardList: _templateData,
      //       isEmpty: res?.data?.orgs[0]?.childrenOrgs.length <= 0,
      //       activePage: totalCount / args?.offset || 1,
      //       pageSize: 12,
      //       totalCount: totalCount,
      //       totalPages: Math.ceil(totalCount / (args?.size ?? 12)),
      //     };
      //   }
      // }
      return {
        ...config,
      };
    } catch (err: any) {
      throw err;
    }
  }

  private formatHolderGroup(data: any) {
    console.log('formatHolderGroup =>', data);
    let _appCard = data.map((item: any) => {
      return {
        ...item,
        appCardId: item?.id,
        appCardImage: item?.logo,
        appCardTitle: item?.name,
        appCardDescription: item?.description,
      };
    });

    return _appCard;
  }
}
